import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "ygams_token";

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use((res) => {
  const m = (res.config?.method || "").toLowerCase();
  if (["post", "put", "patch"].includes(m) && !/\/(next-steps|auth|ai|wa\/status|notifications)/.test(res.config?.url || "")) window.dispatchEvent(new Event("ygams:mutation"));
  return res;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  return d?.msg || String(d);
}

export async function downloadExport(collection, format, custom) {
  const url = custom || `/export/${collection}?format=${format}`;
  const res = await api.get(url, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(res.data);
  a.download = m ? m[1] : `ygams_${collection}.${format}`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function openFile(fileId) {
  const res = await api.get(`/files/${fileId}`, { responseType: "blob" });
  window.open(URL.createObjectURL(res.data), "_blank");
}
